import api from "./axios";
import {
  AdminUserCreateInput,
  AdminUserList,
  AdminUserRow,
  AdminUserUpdateInput,
  UserRole,
} from "../types/users";

type OrderField = "id" | "fullname" | "email" | "role" | "last_seen_at" | "subscription_expires_on";

export async function listAdminUsers(params: {
  page?: number;
  per_page?: number;
  role?: UserRole | null;
  company_id?: number | null;
  order_by?: OrderField | null;
  order_dir?: "asc" | "desc" | null;
  hide_expired_subscription?: boolean | null;
  q?: string | null;
} = {}) {
  const { data } = await api.get<AdminUserList>("/users", {
    params: {
      page: params.page ?? 1,
      per_page: params.per_page ?? 20,
      q: params.q?.trim() || null,
      role: params.role ?? null,
      company_id: params.company_id ?? null,
      order_by: params.order_by ?? "id",
      order_dir: params.order_dir ?? "desc",
      hide_expired_subscription: params.hide_expired_subscription ?? null,
    },
  });
  return data;
}

export async function createAdminUser(payload: AdminUserCreateInput) {
  const { data } = await api.post<AdminUserRow>("/users", payload);
  return data;
}

export async function updateAdminUser(userId: number, payload: AdminUserUpdateInput) {
  const { data } = await api.patch<AdminUserRow>(`/users/${userId}`, payload);
  return data;
}

export async function deleteAdminUser(userId: number) {
  await api.delete(`/users/${userId}`);
}
